import { ReactNode } from "react";
import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, RULES } from "./theme";
import { Fonts } from "./Fonts";

/**
 * The 2D Cold Compute / Neon stage: deep radial background, a faint 12-column
 * grid, a low-opacity scanline grain, and the series fonts. 3D is opt-in per
 * scene (a sibling R3F layer), never the default. Scenes render their own
 * <SlideTimeBar> so it reflects the scene's duration.
 */
export const Stage: React.FC<{
  children: ReactNode;
  grid?: boolean;
  grain?: boolean;
  /** Identical series fonts may be loaded from bundled assets for offline renders. */
  fontLoader?: ReactNode;
}> = ({ children, grid = true, grain = true, fontLoader }) => (
  <AbsoluteFill
    style={{
      background: `radial-gradient(120% 120% at 50% 0%, #0E1320 0%, ${COLORS.bg} 55%, ${COLORS.bg2} 100%)`,
      fontFamily: FONTS.body,
      color: COLORS.text,
    }}
  >
    {fontLoader ?? <Fonts />}
    {grid && (
      <AbsoluteFill
        style={{
          opacity: 0.05,
          backgroundImage: `linear-gradient(90deg, ${COLORS.cyan} 1px, transparent 1px)`,
          backgroundSize: "8.3333% 100%",
          WebkitMaskImage:
            "radial-gradient(120% 90% at 50% 40%, #000 30%, transparent 82%)",
          maskImage:
            "radial-gradient(120% 90% at 50% 40%, #000 30%, transparent 82%)",
          pointerEvents: "none",
        }}
      />
    )}
    {grain && (
      <AbsoluteFill
        style={{
          opacity: RULES.grainOpacity,
          mixBlendMode: "screen",
          backgroundImage:
            "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 3px)",
          pointerEvents: "none",
        }}
      />
    )}
    {children}
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
